import { render, staticRenderFns } from "./VoyageList.vue?vue&type=template&id=1c8b2460&scoped=true&"
import script from "./VoyageList.vue?vue&type=script&lang=js&"
export * from "./VoyageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8b2460",
  null
  
)

export default component.exports